export enum ERequestSupportStatus {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  WAITING = 'WAITING',
  COMPLETED = 'COMPLETED',
}

export const RequestSupportStatusOptions = [
  { label: 'New', value: ERequestSupportStatus.NEW },
  { label: 'In Progress', value: ERequestSupportStatus.IN_PROGRESS },
  { label: 'Waiting', value: ERequestSupportStatus.WAITING },
  { label: 'Completed', value: ERequestSupportStatus.COMPLETED },
];

export const RequestSupportStatusConfig = {
    [ERequestSupportStatus.NEW]: {
        title: 'New',
        background: '#DBEFFF',
        color: '#008BFF',
    },
    [ERequestSupportStatus.IN_PROGRESS]: {
        title: 'In Progress',
        background: '#FEEFE8',
        color: '#FF7D00',
    },
    [ERequestSupportStatus.WAITING]: {
        title: 'Waiting',
        background: '#F1EFFF',
        color: '#9747FF',
    },
    [ERequestSupportStatus.COMPLETED]: {
        title: 'Completed',
        background: '#ECFDF8',
        color: '#0DA472',
    },
};

export enum ERequestPriority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}

export const RequestPriorityOptions = [
  { label: 'Low', value: ERequestPriority.LOW },
  { label: 'Medium', value: ERequestPriority.MEDIUM },
  { label: 'High', value: ERequestPriority.HIGH },
];

export const RequestPriorityConfig = {
    [ERequestPriority.LOW]: {
        title: 'Low',
        color: '#566A7F',
        background: '#EAEDED',
    },
    [ERequestPriority.MEDIUM]: {
        title: 'Medium',
        color: '#A95A23',
        background: '#FEEDBF',
    },
    [ERequestPriority.HIGH]: {
        title: 'High',
        color: '#D2464F',
        background: '#FFE5E7',
    },
};